import "./ListGroup_module.css";
const ListGroup_module_rslib_entry_ = {
    ListGroup: "ListGroup-sP5Ld7",
    listGroup: "ListGroup-sP5Ld7"
};
export { ListGroup_module_rslib_entry_ as default };

//# sourceMappingURL=ListGroup.module.js.map